export enum EdeliveryAddressContext {
  Personal = 'personal',
  Company = 'company',
}
